import { Collapse, Divider } from "antd";
import {
	ActionButtonComponent,
	AddDocumentContainer,
	AddItemsContainer,
} from "./style";
import { DocCategoryItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useDocumentContext } from "../../context/DocumentContext/DocumentContext";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

const AddDocumentCategory = () => {
	const { id } = useParams<{ id: string }>();
	const { addDocument, getDocumentCategoryDetail, operationStatus } = useDocumentContext();

	useEffect(() => {
		if (id) {
			getDocumentCategoryDetail(id);
		}
	}, [id]);

	return (
		<AddDocumentContainer>
			<AddItemsContainer>
				<h3>Yeni Doküman Ekleme</h3>
				<Divider />
				<Collapse
					items={DocCategoryItems}
					expandIconPosition="end"
					bordered={false}
					expandIcon={({ isActive }) => (
						<UpOutlined rotate={isActive ? 0 : -180} />
					)}
					defaultActiveKey={["1", "2"]}
				/>
				<ActionButtonComponent>
					<MainButtonComponent onClick={addDocument} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Dokümanı Ekle
					</MainButtonComponent>
				</ActionButtonComponent>
			</AddItemsContainer>
		</AddDocumentContainer>
	);
};

export default AddDocumentCategory;
